import React from 'react';

import {Nav} from 'react-bootstrap';

import * as IconFi from 'react-icons/fi';
import * as IconGr from 'react-icons/gr';
import * as IconFa from 'react-icons/fa';
import * as IconSi from 'react-icons/si';
import {ReactComponent as ImgTelegram} from '../../../asset/img/icon/telegram.svg';
import {ReactComponent as ImgAparat} from '../../../asset/img/icon/aparat.svg';

const SocialNetworks = props => {

    const icons = [
        {name: 'instagram', icon: <IconFi.FiInstagram size={24}/>},
        {name: 'twitter', icon: <IconGr.GrTwitter size={24}/>},
        {name: 'facebook', icon: <IconGr.GrFacebookOption size={24}/>},
        {name: 't.me', icon: <ImgTelegram/>},
        {name: 'aparat', icon: <ImgAparat/>},
        {name: 'linkedin', icon: <IconFa.FaLinkedinIn size={24}/>},
        {name: 'youtube', icon: <IconSi.SiYoutube size={24}/>}
    ]

    // -----------------------------------------------------------------------------------------------------------------

    const renderItem = item => {
        return (icons.find(({name}) => item.includes(name)) ? <Nav.Link href={item} target="_blank" className="p-2 m-1 text-reset">{icons.find(({name}) => item.includes(name)).icon}</Nav.Link> : '')
    }

    // -----------------------------------------------------------------------------------------------------------------

    return (
        <>
            {
                props.data?.map((item, index) => <React.Fragment key={index}>{renderItem(item)}</React.Fragment>)
            }
        </>
    )
}

export default SocialNetworks;